import {useState} from "react";

import TabPanel from "@mui/lab/TabPanel";
import NewsDetailThumbnail from "../../../component/magazine/NewsDetailThumbnail";
import NewsDetailBaseInfo from "../../../component/magazine/NewsDetailBaseInfo";
import Tab from "@mui/material/Tab";
import TabList from "@mui/lab/TabList";
import Box from "@mui/material/Box";
import TabContext from "@mui/lab/TabContext";
import SeoComponent from "../../../component/seo/SeoComponent";
import {RouteHelper} from "../../../route/RouteHelper";
import {useLocation, useNavigate} from "react-router-dom";
import {MagazineService} from "../../../serverService/magazineService/MagazineService";
import TagSelection from "../../../component/magazine/tagSelection/TagSelection";
import MagazineCategory from "../../../component/magazine/magazineCategory/MagazineCategory";
import {css} from "@emotion/css";
import {
    RaikoBaseContainer,
    RaikoBreadcrumb, raikoBreadCrumbItemGenerator, RaikoButtonSecondary,
    RaikoFlexFirstChildGrowOne,
    RaikoGridOneColumn
} from "@moeindal/base-raiko-panel-components";
import {useParams} from "react-router-dom";

const MagazineDetails = () => {
    const {id: blogID} = useParams()

    const navigate = useNavigate()
    const {state} = useLocation()
    const [pageTitle, setPageTitle] = useState(state && state.title ? state.title : RouteHelper.MagazineDetail.name);

    const [tabSelectedValue, setTabSelectedValue] = useState(newsTabTypes.newsDetail.id);

    function handleChangeTab(event, newValue) {
        setTabSelectedValue(newValue)
    }

    return (
        <RaikoBaseContainer>
            <RaikoGridOneColumn>
                <RaikoFlexFirstChildGrowOne>
                    <RaikoBreadcrumb
                        breadCrumbItems={[
                            raikoBreadCrumbItemGenerator(
                                RouteHelper.MagazineList.name,
                                RouteHelper.MagazineList.globalUrl
                            ),
                            raikoBreadCrumbItemGenerator(
                                pageTitle,
                                ""
                            ),
                        ]}/>

                    <RaikoButtonSecondary
                        label={"بازگشت"}
                        onClick={_ => {
                            navigate(RouteHelper.MagazineList.globalUrl)
                        }}/>
                </RaikoFlexFirstChildGrowOne>

                <TabContext value={tabSelectedValue}>
                    <Box sx={{borderBottom: 1, borderColor: 'divider'}} className={css`
                      border-color: var(--header-border-bottom-color) !important;
                    `}>
                        <TabList onChange={handleChangeTab} id="default-tab-container" variant="scrollable">
                            <Tab icon={<div id="tabIcon"/>} iconPosition="start"
                                 label={newsTabTypes.newsDetail.title}
                                 value={newsTabTypes.newsDetail.id}/>

                            <Tab icon={<div id="tabIcon"/>} iconPosition="start"
                                 label={newsTabTypes.magazineCategory.title}
                                 value={newsTabTypes.magazineCategory.id}/>

                            <Tab icon={<div id="tabIcon"/>} iconPosition="start"
                                 label={newsTabTypes.magazineTag.title}
                                 value={newsTabTypes.magazineTag.id}/>

                            <Tab icon={<div id="tabIcon"/>} iconPosition="start"
                                 label={newsTabTypes.seoDetail.title}
                                 value={newsTabTypes.seoDetail.id}/>
                        </TabList>
                    </Box>
                    <TabPanel value={newsTabTypes.newsDetail.id}>
                        <RaikoGridOneColumn>
                            <NewsDetailThumbnail blogID={blogID}/>
                            <NewsDetailBaseInfo setPageTitle={setPageTitle} blogID={blogID}/>
                        </RaikoGridOneColumn>
                    </TabPanel>

                    <TabPanel value={newsTabTypes.magazineTag.id}>
                        <RaikoGridOneColumn>
                            <TagSelection blogID={blogID}/>
                        </RaikoGridOneColumn>
                    </TabPanel>
                    <TabPanel value={newsTabTypes.magazineCategory.id}>
                        <RaikoGridOneColumn>
                            <MagazineCategory blogID={blogID}/>
                        </RaikoGridOneColumn>
                    </TabPanel>

                    <TabPanel value={newsTabTypes.seoDetail.id}>
                        <SeoComponent serviceInstance={new MagazineService()} />
                    </TabPanel>
                </TabContext>
            </RaikoGridOneColumn>
        </RaikoBaseContainer>
    )
}


const newsTabTypes = {
    newsDetail: {
        id: "news-detail",
        title: "اطلاعات پایه"
    }, thumbnail: {
        id: "news-thumbnail",
        title: "تصویر شاخص"
    }, seoDetail: {
        id: "seo-detail",
        title: "بهینه سازی موتور جستجو"
    }, magazineTag: {
        id: "magazine-tag",
        title: "تگ"
    },
    magazineCategory: {
        id: "magazine-category",
        title: "دسته بندی"
    },

}


export default MagazineDetails